import styled from 'styled-components';

import BREAKPOINTS from 'styles/breakpoints';
import { H6, weight } from 'styles/typography';

const Heading = styled(H6)`
  margin: 26px 0 20px;

  ${BREAKPOINTS.small`
    margin-bottom: 25px;
    font-weight: ${weight.bold};
  `}
`;

const ScrollToHeading = ({ children }) => {
  const htmlId = children?.toLowerCase().replace(/\s/g, '-');
  return (
    <Heading id={htmlId} as="h2">
      {children}
    </Heading>
  );
};

export default ScrollToHeading;
